/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ThemeToggle from './ThemeToggle';
import './AppNav.css';

const AppNav: React.FC = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, signOut, isDemo } = useAuth();
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia?.('(max-width: 768px)').matches ?? false
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia?.('(max-width: 768px)');
    if (!mediaQuery) return undefined;
    const handleChange = () => setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  const navLinks = [
    { path: '/app/deal-analyzer', label: 'Deal Analyzer' },
    { path: '/app/portfolio', label: 'Deal Pipeline' },
    { path: '/app/sourcing', label: 'Sourcing' },
    { path: '/app/my-properties', label: 'My Properties' },
    { path: '/app/expense-income', label: 'Expenses & Income' },
    { path: '/app/reports', label: 'Reports' },
    { path: '/app/market-analysis', label: 'Market Analysis' },
  ];

  // Add admin link if user is admin
  if (user?.is_admin) {
    navLinks.push({ path: '/app/admin', label: 'Admin' });
  }

  const handleLogout = async () => {
    await signOut();
    setMobileMenuOpen(false);
  };

  return (
    <nav className="app-nav">
      <div className="app-nav-container">
        <Link to="/" className="app-nav-brand">
          <img
            src={`${process.env.PUBLIC_URL}/logo.png`}
            alt="Vista Strategic Management"
            className="app-nav-brand-logo"
          />
        </Link>

        <button
          type="button"
          className="app-mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
          aria-expanded={mobileMenuOpen}
          aria-controls="app-navigation-links"
        >
          <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false">
            <path d="M4 7h16M4 12h16M4 17h16" />
          </svg>
        </button>

        <div
          id="app-navigation-links"
          className={`app-nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}
          aria-hidden={isMobile && !mobileMenuOpen}
          inert={isMobile && !mobileMenuOpen}
        >
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`app-nav-link ${location.pathname === link.path ? 'active' : ''}`}
              tabIndex={isMobile && !mobileMenuOpen ? -1 : undefined}
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/"
            className="app-nav-link app-nav-public"
            tabIndex={isMobile && !mobileMenuOpen ? -1 : undefined}
            onClick={() => setMobileMenuOpen(false)}
          >
            Public Site
          </Link>
          <ThemeToggle />
          {user && (
            <div className="app-nav-user">
              {isDemo && <span className="app-nav-demo-badge">Demo Mode</span>}
              <span className="app-nav-username">{user.full_name || user.email}</span>
              <button onClick={handleLogout} className="app-nav-logout">
                {isDemo ? 'Exit Demo' : 'Logout'}
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default AppNav;
